export default function TermsOfUseContent() {
	return (
		<>
			<section className="mb-10">
				<p className="text-zinc-700 leading-relaxed">
					Estes Termos de Uso estabelecem as condições aplicáveis ao acesso ao site e à utilização das soluções oferecidas pela Grinsper.
					Assim como nossa Política de Privacidade, este documento foi escrito de forma clara e objetiva para refletir nosso compromisso com relações transparentes entre pessoas, organizações e tecnologia.
				</p>

				<p className="text-zinc-700 leading-relaxed mt-4">
					Estes Termos aplicam-se a todas as soluções disponibilizadas pela Grinsper destinadas a pessoas físicas e organizações.
					Quando um serviço possuir condições específicas, elas complementarão estes Termos.
				</p>

				<div className="text-zinc-700 leading-relaxed mt-6">
					Para os fins deste documento, adotamos as seguintes definições:

					<ul className="list-disc list-inside space-y-2 mt-4">
						<li><strong>Solicitante:</strong> pessoa que solicita um serviço da Grinsper.</li>

						<li><strong>Titular do Produto:</strong> pessoa ou organização responsável pelo produto digital submetido à avaliação, quando aplicável.</li>

						<li><strong>Titular de Dados:</strong> pessoa natural cujos dados pessoais são tratados pela Grinsper ou pelo produto avaliado.</li>
					</ul>
				</div>

				<p className="text-zinc-700 leading-relaxed mt-6">
					Caso permaneça qualquer dúvida sobre estes Termos, nossa equipe estará disponível através do e-mail
					{" "}
					<a
						href="mailto:transparencia@grinsper.com"
						className="custom-link custom-link-hover-color font-medium text-zinc-900 underline underline-offset-4"
					>
						transparencia@grinsper.com
					</a>.
				</p>
			</section>

			<section className="mb-10">
				<h2 className="text-xl font-medium mb-3 text-zinc-800">
					1. Condições de utilização
				</h2>

				<p className="text-zinc-700 leading-relaxed">
					Ao utilizar o site da Grinsper ou solicitar qualquer uma de nossas soluções, você declara que leu, compreendeu e concorda com estes Termos de Uso.
				</p>

				<p className="text-zinc-700 leading-relaxed mt-4">
					A solicitação de um serviço não gera obrigação de contratação para nenhuma das partes e não garante sua execução.
					Algumas soluções estão sujeitas à análise prévia de elegibilidade, disponibilidade técnica ou definição de escopo.
				</p>

				<p className="text-zinc-700 leading-relaxed mt-4">
					Quando o Solicitante atuar em nome de uma organização ou do Titular do Produto, declara possuir autorização para representar essa entidade durante as etapas de solicitação, contratação e execução do serviço.
				</p>

				<p className="text-zinc-700 leading-relaxed mt-4">
					Caso algum ponto destes Termos não esteja claro ou não faça sentido para o seu contexto, recomendamos que entre em contato conosco antes de prosseguir.
				</p>
			</section>

			<section className="mb-10">
				<h2 className="text-xl font-medium mb-3 text-zinc-800">
					2. Responsabilidades do Solicitante
				</h2>

				<p className="text-zinc-700 leading-relaxed">
					Esperamos que a utilização das soluções da Grinsper reflita os mesmos princípios que orientam nosso trabalho:
					boa-fé, transparência, respeito à privacidade e colaboração.
				</p>

				<p className="text-zinc-700 leading-relaxed mt-5 font-medium">
					Quando a solicitação envolver organizações ou produtos digitais:
				</p>

				<ul className="list-disc list-inside text-zinc-700 leading-relaxed space-y-2 mt-3">
					<li>Solicitar serviços apenas quando possuir autorização para representar o Titular do Produto.</li>

					<li>Fornecer informações verdadeiras e suficientes para definição do escopo e execução do serviço.</li>

					<li>Disponibilizar acessos, ambientes ou informações técnicas somente quando necessários à execução.</li>

					<li>
						Sempre que forem necessários usuários de teste, fornecer exclusivamente
						<strong> dados sintéticos</strong>, evitando o compartilhamento de dados pessoais reais.
					</li>

					<li>Não utilizar as soluções da Grinsper para fins ilícitos, abusivos ou que violem direitos de terceiros.</li>

					<li>Não tentar reproduzir, copiar, desmontar, realizar engenharia reversa ou extrair metodologias, frameworks ou processos internos desenvolvidos pela Grinsper.</li>
				</ul>

				<p className="text-zinc-700 leading-relaxed mt-6 font-medium">
					Quando a solicitação envolver serviços destinados a pessoas físicas:
				</p>

				<ul className="list-disc list-inside text-zinc-700 leading-relaxed space-y-2 mt-3">
					<li>Fornecer apenas informações verdadeiras sobre a situação apresentada.</li>

					<li>Compartilhar apenas dados necessários para análise do caso.</li>

					<li>Evitar o envio de dados pessoais de terceiros sem autorização ou fundamento legal.</li>

					<li>Não utilizar os serviços da Grinsper para fins ilícitos ou abusivos.</li>
				</ul>
			</section>

			<section className="mb-10">
				<h2 className="text-xl font-medium mb-3 text-zinc-800">
					3. Acesso aos serviços e comunicações
				</h2>

				<p className="text-zinc-700 leading-relaxed">
					As soluções da Grinsper são disponibilizadas por meio do nosso site e, quando necessário, por canais oficiais de comunicação, como e-mail e WhatsApp.
				</p>

				<p className="text-zinc-700 leading-relaxed mt-4">
					Os diagnósticos, orientações, propostas, relatórios e demais entregáveis poderão ser enviados por esses canais, conforme a natureza do serviço contratado.
				</p>

				<p className="text-zinc-700 leading-relaxed mt-4">
					Para preservar a segurança das informações, o Solicitante compromete-se a manter protegidos os meios de comunicação utilizados durante o atendimento.
				</p>

				<ul className="list-disc list-inside text-zinc-700 leading-relaxed space-y-2 mt-4">
					<li>Manter o acesso ao e-mail e aos dispositivos utilizados protegido contra terceiros.</li>

					<li>Não compartilhar links privados ou documentos recebidos da Grinsper com pessoas não autorizadas.</li>

					<li>Comunicar imediatamente caso identifique acesso indevido aos canais utilizados durante o atendimento.</li>
				</ul>

				<p className="text-zinc-700 leading-relaxed mt-4">
					A Grinsper não poderá ser responsabilizada por acessos realizados por terceiros quando decorrentes da perda de credenciais, compartilhamento voluntário ou falhas de segurança sob responsabilidade do próprio Solicitante.
				</p>
			</section>

			<section className="mb-10">
				<h2 className="text-xl font-medium mb-3 text-zinc-800">
					4. Contratação, cancelamento e reembolso
				</h2>

				<p className="text-zinc-700 leading-relaxed">
					As condições comerciais de cada solução serão apresentadas antes da contratação.
					O envio de uma solicitação inicial ou a realização de uma análise preliminar não caracteriza contratação do serviço.
				</p>

				<p className="text-zinc-700 leading-relaxed mt-4">
					Por se tratar de serviços técnicos, personalizados e predominantemente intelectuais, o cancelamento com reembolso integral somente poderá ocorrer antes do início efetivo da execução pela equipe da Grinsper.
				</p>

				<p className="text-zinc-700 leading-relaxed mt-4">
					Após o início da avaliação, diagnóstico, orientação técnica ou elaboração dos entregáveis, considera-se iniciado o cumprimento da obrigação contratual, hipótese em que não haverá devolução dos valores pagos, ressalvadas as situações previstas na legislação aplicável.
				</p>

				<p className="text-zinc-700 leading-relaxed mt-4">
					Quando aplicável, contratos específicos poderão prever condições complementares sobre cancelamento, reembolso, planos recorrentes ou alterações de escopo.
				</p>
			</section>

			<section className="mb-10">
				<h2 className="text-xl font-medium mb-3 text-zinc-800">
					5. Propriedade intelectual e entregáveis
				</h2>

				<p className="text-zinc-700 leading-relaxed">
					A Grinsper desenvolve metodologias próprias para avaliação da experiência de privacidade.
					Esses ativos intelectuais permanecem sob sua exclusiva titularidade, independentemente da contratação de qualquer serviço.
				</p>

				<ul className="list-disc list-inside text-zinc-700 leading-relaxed space-y-3 mt-4">
					<li>
						<strong>São de propriedade da Grinsper:</strong> metodologias, frameworks, modelos de avaliação, critérios técnicos, tecnologias, código-fonte, identidade visual, marcas, documentação interna, processos, fluxos e todo o conhecimento empregado na prestação dos serviços.
					</li>

					<li>
						<strong>São de propriedade do cliente contratante:</strong> relatórios finais, diagnósticos, pareceres, recomendações, mapas de jornada e demais entregáveis produzidos especificamente para aquele atendimento.
					</li>
				</ul>

				<p className="text-zinc-700 leading-relaxed mt-4">
					Quando o serviço envolver um produto digital pertencente a uma organização, os entregáveis pertencem ao Titular do Produto, ainda que a solicitação tenha sido realizada por outro representante autorizado.
				</p>

				<p className="text-zinc-700 leading-relaxed mt-4 italic text-sm">
					A contratação dos serviços não transfere ao cliente qualquer direito sobre as metodologias, tecnologias ou propriedade intelectual utilizadas pela Grinsper para produzir os resultados.
				</p>
			</section>

			<section className="mb-10">
				<h2 className="text-xl font-medium mb-3 text-zinc-800">
					6. Limitação de responsabilidade
				</h2>

				<p className="text-zinc-700 leading-relaxed">
					A Grinsper compromete-se a executar seus serviços com diligência, independência técnica e observância das boas práticas relacionadas à privacidade e proteção de dados.
				</p>

				<p className="text-zinc-700 leading-relaxed mt-4">
					Entretanto, a qualidade, o prazo e o resultado da prestação dos serviços também dependem da colaboração do Solicitante e das condições do ambiente analisado.
				</p>

				<ul className="list-disc list-inside text-zinc-700 leading-relaxed space-y-2 mt-4">
					<li>
						O cumprimento dos prazos poderá depender do fornecimento tempestivo de informações, acessos, ambientes de teste ou dados sintéticos quando necessários.
					</li>

					<li>
						Alterações significativas realizadas no produto durante a execução poderão exigir revisão do escopo, renegociação de prazos ou contratação complementar.
					</li>

					<li>
						Eventuais indisponibilidades causadas por terceiros, serviços de hospedagem, provedores, falhas de infraestrutura ou eventos imprevisíveis poderão impactar a execução do serviço.
					</li>
				</ul>

				<p className="text-zinc-700 leading-relaxed mt-4">
					As recomendações produzidas pela Grinsper possuem natureza técnica e consultiva.
					A decisão sobre sua implementação permanece sob responsabilidade do cliente.
				</p>

				<p className="text-zinc-700 leading-relaxed mt-4">
					A Grinsper não garante resultados comerciais específicos, aumento de conversão, ausência de incidentes de segurança, conformidade regulatória integral ou qualquer decisão tomada exclusivamente com base nos relatórios fornecidos.
				</p>
			</section>

			<section className="mb-10">
				<h2 className="text-xl font-medium mb-3 text-zinc-800">
					7. Alterações destes Termos
				</h2>

				<p className="text-zinc-700 leading-relaxed">
					A Grinsper poderá atualizar estes Termos de Uso sempre que isso for necessário para refletir melhorias em seus serviços, alterações na legislação aplicável, evolução de suas soluções ou aperfeiçoamento de seus processos internos.
				</p>

				<p className="text-zinc-700 leading-relaxed mt-4">
					Sempre que as alterações impactarem de forma relevante a utilização dos serviços, adotaremos medidas razoáveis para informar os usuários pelos canais oficiais da Grinsper ou por meio do próprio site.
				</p>

				<p className="text-zinc-700 leading-relaxed mt-4">
					A versão mais recente destes Termos permanecerá disponível para consulta e substituirá integralmente as versões anteriores.
				</p>
			</section>

			<section className="mb-10">
				<h2 className="text-xl font-medium mb-3 text-zinc-800">
					8. Relação com a Política de Privacidade
				</h2>

				<p className="text-zinc-700 leading-relaxed">
					Estes Termos complementam nossa Política de Privacidade. Enquanto este documento estabelece as regras de utilização do site e dos serviços da Grinsper, a Política de Privacidade descreve como tratamos os dados pessoais durante esse relacionamento.
				</p>

				<p className="text-zinc-700 leading-relaxed mt-4">
					Recomendamos a leitura conjunta dos dois documentos para uma compreensão completa dos direitos, responsabilidades e compromissos assumidos entre a Grinsper, pessoas e organizações que utilizam nossas soluções.
				</p>
			</section>

			<section className="mb-10">
				<h2 className="text-xl font-medium mb-3 text-zinc-800">
					9. Contato
				</h2>

				<p className="text-zinc-700 leading-relaxed mb-4">
					Acreditamos que transparência também significa estar disponível para esclarecer dúvidas. Caso você tenha qualquer questionamento sobre estes Termos de Uso, sobre nossas soluções ou sobre o relacionamento com a Grinsper, entre em contato conosco.
				</p>

				<div className="bg-zinc-50 border border-zinc-200 p-6 rounded-lg">
					<a
						href="mailto:transparencia@grinsper.com"
						className="custom-link font-medium text-zinc-900 underline underline-offset-4"
					>
						transparencia@grinsper.com
					</a>
				</div>
			</section>

			<section className="mb-10 border-t border-zinc-100 pt-5">
				<p className="text-sm text-zinc-500 leading-relaxed italic">
					Estes Termos refletem nosso compromisso com relações baseadas em transparência, autonomia e confiança.
					Continuaremos evoluindo este documento à medida que nossas soluções amadureçam, sempre buscando tornar nossas práticas mais claras e compreensíveis.
				</p>

				<p className="text-xs text-zinc-400 mt-4">
					O conteúdo destes Termos de Uso é propriedade intelectual da © {new Date().getFullYear()} Grinsper.
					Sua reprodução total ou parcial, inclusive metodologias, textos e estrutura, sem autorização prévia, é proibida e protegida pela Lei nº 9.610/98.
				</p>

				<p className="text-center text-sm text-zinc-500 italic mt-3 mb-3">
					Versão 1.0 (atualizada em 30.06.2026) | Grinsper Inova Simples I.S. | CNPJ: 64.967.842/0001-08
				</p>
			</section>
		</>
	);
}
